module.exports = __webpack_public_path__ + "a5f3cf95cd994f488e43ec254dfd043f.jpg";